import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";

const Radio = ({
  name,
  value,
  checked,
  onChange,
  label,
  disabled,
  className,
  id,
  ...props
}) => (
  <div className={clsx("inline-block relative", className)}>
    <input
      type="radio"
      name={name}
      value={value}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      {...props}
      id={id}
      className={clsx(
        "absolute -z-10 opacity-0 [&+label>.radio]:border-gray-200  opacity-0 [&+label>.radio]:text-transparent [&:checked+label>.radio]:border-[rgba(var(--primary-rgb)/100%)] [&:checked+label>.radio]:text-[rgba(var(--primary-rgb)/100%)]"
      )}
    />
    <label htmlFor={id} className="inline-flex cursor-pointer">
      <span className="radio border min-w-6 min-h-6 w-6 h-6 rounded-full flex items-center justify-center">
        <span className="block rounded-full min-w-3 min-h-3 w-3 h-3 bg-[currentColor]"></span>
      </span>
      <span className="pl-2.5">{label}</span>
    </label>
  </div>
);

Radio.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
};

export default Radio;
